import script from "./KCategoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCategoryCard.vue?vue&type=script&setup=true&lang=ts"

import "./KCategoryCard.vue?vue&type=style&index=0&id=d18d9a60&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d18d9a60"]])

export default __exports__